var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointmentsDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.66797H1.5M12.3333 1.66797V4.16797M5.66667 1.66797V4.16797M5.5 18.3346H12.5C13.9001 18.3346 14.6002 18.3346 15.135 18.0622C15.6054 17.8225 15.9878 17.44 16.2275 16.9696C16.5 16.4348 16.5 15.7348 16.5 14.3346V7.33464C16.5 5.9345 16.5 5.23444 16.2275 4.69966C15.9878 4.22925 15.6054 3.8468 15.135 3.60712C14.6002 3.33464 13.9001 3.33464 12.5 3.33464H5.5C4.09987 3.33464 3.3998 3.33464 2.86502 3.60712C2.39462 3.8468 2.01217 4.22925 1.77248 4.69966C1.5 5.23444 1.5 5.9345 1.5 7.33464V14.3346C1.5 15.7348 1.5 16.4348 1.77248 16.9696C2.01217 17.44 2.39462 17.8225 2.86502 18.0622C3.3998 18.3346 4.09987 18.3346 5.5 18.3346ZM8.99772 10.2768C8.33127 9.5193 7.21992 9.31554 6.3849 10.0092C5.54988 10.7028 5.43232 11.8625 6.08807 12.6829C6.56417 13.2785 7.88272 14.451 8.56944 15.0487C8.71831 15.1783 8.79275 15.2431 8.87997 15.2688C8.95553 15.2911 9.0399 15.2911 9.11546 15.2688C9.20268 15.2431 9.27712 15.1783 9.42599 15.0487C10.1127 14.451 11.4313 13.2785 11.9074 12.6829C12.5631 11.8625 12.4599 10.6955 11.6105 10.0092C10.7612 9.32283 9.66417 9.5193 8.99772 10.2768Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentsDark);
export default __webpack_public_path__ + "static/media/appointments-dark.a99ff42786adc734062f07b80627bb0e.svg";
export { ForwardRef as ReactComponent };